export const documentListData = [
    {
        docName: "National ID",
        download: true,
        documentType: "form_i9",

        title: "National ID: Provide your passport or driving license, providing the page containing the holder's personal details including nationality, holder's photograph, holder's signature, date of expiry and information indicating the holder has permission to enter or remain in the UK and is permitted to work *"
    },
    {
        docName: "P-45 Form",
        download: true,
        documentType: "wa_form",
        title: "Provide your P-45 document from your last employer containing your national insurance and tax info *"
    },
    {
        docName: "Highest Level Of Education",
        download: false,
        documentType: "highest_education",
        title: "Provide a copy of highest level of education (diploma or transcripts) *",
        fileType: ["application/pdf", "image/jpeg", "image/jpg", "image/png", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"],
        maxFileSize: 5 * 1000 * 1000,
    },
    {
        docName: "Utility bill",
        download: false,
        documentType: "pay_check",
        fileType: ["application/pdf", "image/jpeg", "image/jpg", "image/png", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"],
        maxFileSize: 5 * 1000 * 1000,
        title: "Provide a copy of any utility bill confirming your current residence address *"
    }
]


 

export const docHandler = (index, dispatch, setUsaHiringDocuments, inputDocData, documentType, docName, state = null) => {
    if (state === null) {
        const { link, type, name } = inputDocData
        dispatch(setUsaHiringDocuments({ index, data: { base64: link, documentName: docName, type, documentType } }))
    }
    else {
        dispatch(setUsaHiringDocuments({ ...state.uploadedDocuments, index, data: { base64: null, documentName: '', type: '', documentType: '' } }))
    }
}


export const  formDocumentUrl={

    "W4 Form":{
        fileUrl:"https://curatedprdstgacct.blob.core.windows.net/curated-prd/assets/W4_Form_08f3868961.pdf"
    },
    "Form I9":{
        fileUrl:"https://curatedprdstgacct.blob.core.windows.net/curated-prd/assets/Form_I9_9f94b7bac2.pdf"  
    }

}

